<!-- <div *ngFor="let round of penalties.penalties" class="round" [class.scored]="round === 'Scored'" [class.missed]="round === 'Missed'"></div> -->
<div class="penalty-points">
    @for (round of penalties.penalties; track $index) {
        <div class="round" [class.scored]="round === 'Scored'" [class.missed]="round === 'Missed'">
            @switch (round) {
                @case ('Scored') {
                    <ng-container *ngTemplateOutlet="scoredTemplate" />
                }
                @case ('Missed') {
                    <ng-container *ngTemplateOutlet="missedTemplate" />
                }
                @default {
                    <svg></svg>
                }
            }
        </div>
    }
</div>

<ng-template #scoredTemplate>
    <svg>
        <path
            d="M5.19668745,7.48448828 C4.80049228,7.09971843 4.16739505,7.10898047 3.7826252,7.50517563 C3.39785535,7.90137079 3.40711739,8.53446803 3.80331255,8.91923788 L6.16969009,11.2173748 C6.55771334,11.5942084 7.17504172,11.5942084 7.56306498,11.2173748 L12.1966874,6.7173748 C12.5928826,6.33260495 12.6021447,5.69950772 12.2173748,5.30331255 C11.8326049,4.90711739 11.1995077,4.89785535 10.8033126,5.2826252 L6.86637753,9.10602854 L5.19668745,7.48448828 Z" />
    </svg>
</ng-template>
<ng-template #missedTemplate>
    <svg>
        <path
            d="M7.99449513,6.58028156 L9.88188347,4.69289322 C10.2724078,4.30236893 10.9055727,4.30236893 11.296097,4.69289322 C11.6866213,5.08341751 11.6866213,5.71658249 11.296097,6.10710678 L9.40870869,7.99449513 L11.296097,9.88188347 C11.6866213,10.2724078 11.6866213,10.9055727 11.296097,11.296097 C10.9055727,11.6866213 10.2724078,11.6866213 9.88188347,11.296097 L7.99449513,9.40870869 L6.10710678,11.296097 C5.71658249,11.6866213 5.08341751,11.6866213 4.69289322,11.296097 C4.30236893,10.9055727 4.30236893,10.2724078 4.69289322,9.88188347 L6.58028156,7.99449513 L4.69289322,6.10710678 C4.30236893,5.71658249 4.30236893,5.08341751 4.69289322,4.69289322 C5.08341751,4.30236893 5.71658249,4.30236893 6.10710678,4.69289322 L7.99449513,6.58028156 L7.99449513,6.58028156 Z" />
    </svg>
</ng-template>
